export default "__VITE_ASSET__37d3961d__"